export default {
  namespaced: true,
  vlm_analyzer: {
    title: 'Analíticos',
    menu_title: 'Configuración de VLM',
    cameras: 'Cámaras',
    monitoring: 'Monitoreo',
    add_camera: 'Agregar cámara',
    edit_camera: 'Editar cámara',
    select_camera: 'Selecciona una cámara de SBO',
    camera_name: 'Nombre para monitoreo',
    language: 'Idioma de análisis',
    analytics: 'Analíticos',
    created_at: 'Fecha de alta',
    add_analytic: 'Agregar analítico',
    edit_analytic: 'Editar detección',
    event: 'Evento',
    provider: 'Proveedor',
    interval: 'Intervalo',
    analysis_interval: 'Intervalo entre análisis (segundos)',
    reasoning: 'Razonamiento',
    reasoning_off: 'Desactivado',
    reasoning_on: 'Activado',
    reasoning_low: 'Bajo',
    reasoning_medium: 'Medio',
    reasoning_high: 'Alto',
    reasoning_xhigh: 'Muy alto',
    enabled: 'Habilitado',
    camera_enabled: 'Cámara habilitada',
    detection_enabled: 'Detección habilitada',
    paused: 'Pausado',
    status: 'Estado',
    analytic_status: 'Estado del analítico',
    pause_detection: 'Pausar analítico',
    enable_detection: 'Habilitar analítico',
    actions: 'Acciones',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    manage: 'Gestionar',
    refresh: 'Actualizar',
    analyze: 'Analizar ahora',
    search: 'Buscar cámara o Proxy ID',
    no_cameras: 'No hay cámaras configuradas.',
    no_results: 'No hay resultados de monitoreo.',
    saved: 'Configuración guardada correctamente.',
    deleted: 'Configuración eliminada correctamente.',
    load_error: 'No fue posible cargar VLM Analizer.',
    save_error: 'No fue posible guardar la configuración.',
    action_error: 'No fue posible completar la operación.',
    traffic: 'Tráfico',
    fallen_person: 'Persona caída',
    fight: 'Pelea',
    workspace_condition: 'Condiciones del área de trabajo',
    last_analysis: 'Último análisis',
    result: 'Resultado',
    manual_analysis: 'Análisis manual',
    incident_confirmation: 'Confirmación de incidentes',
    alert_cooldown: 'Intervalo entre alertas del mismo episodio (segundos)',
    cooldown_help: '0 envía una alerta en cada análisis que confirme el incidente y cumpla su umbral. Un valor mayor limita las repeticiones del episodio.',
    threshold_help: 'Segundos observados antes de notificar. 0 permite avisar en la primera observación válida.',
    collision: 'Choque · segundos',
    pedestrian_collision: 'Atropellamiento · segundos',
    traffic_congestion: 'Congestión · segundos',
    stalled_vehicle: 'Vehículo detenido · segundos',
    road_obstruction: 'Obstrucción · segundos',
    scene_fire: 'Incendio en escena · segundos',
    flooding: 'Inundación · segundos',
    person_on_road: 'Persona en carretera · segundos',
    animal_on_road: 'Animal en carretera · segundos',
    dangerous_object: 'Objeto peligroso · segundos',
    liquid_spill: 'Derrame de líquido · segundos',
    disallowed_object: 'Objeto no permitido · segundos',
    multimedia_content: 'Contenido multimedia · segundos',
    cluttered_workspace: 'Área de trabajo desordenada · segundos',
  },
}
